import { createI18n } from "vue-i18n";
import { get } from 'lodash';
import en_translation from "./en";
import bg_translation from "./bg";
import { getUserCountry } from '@/services/geolocation';

// List of all locales.
export const allLocales = ["bg", "en", "de"];
const loadedLanguages = ["bg"]; // our default language that is preloaded

let loadedLocale = 'bg';

const translations = {
  bg: bg_translation,
  en: en_translation
}

// Function to determine initial locale based on user's country
export async function determineInitialLocale() {
  // Check if user has a saved preference
  const savedLang = window.localStorage.getItem('defaultLang');
  if (savedLang && allLocales.includes(savedLang)) {
    return savedLang;
  }

  // Try to detect user's country
  try {
    const country = await getUserCountry();
    
    // If user is from Bulgaria, set Bulgarian as default
    if (country === 'BG') {
      return 'bg';
    }
    
    // For all other countries, default to English
    return 'en';
  } catch (error) {
    console.warn('Could not detect user country, defaulting to English:', error);
    return 'en';
  }
}

// Create Vue I18n instance.
export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  // allowComposition: true,
  locale: loadedLocale,
  messages: translations,
  fallbackLocale: "bg",
  // useScope: "global",
  messageResolver: (obj, path) => get(obj, path, '')?.replaceAll(/@/g, "{'@'}") || null,
});

// Set new locale.
// By default, persists the preference to localStorage.
export const setLang = async (lang, { persist = true } = {}) => {
  i18n.global.locale.value = lang;
  // axios.defaults.headers.common["Accept-Language"] = lang;
  document.querySelector("html").setAttribute("lang", lang);
  if (persist) {
    window.localStorage.setItem('defaultLang', lang);
  }
}

// Initialize locale based on user's location
export async function initializeLocale() {
  const initialLocale = await determineInitialLocale();
  await loadLocale(initialLocale);
  return initialLocale;
}

// Fetch locale.
export function loadLocale(lang) {
  // If the same language
  if (i18n.global.locale.value === lang) {
    return Promise.resolve(setLang(lang));
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setLang(lang));
  }

  // If the language wasn't loaded yet
  loadedLanguages.push(lang);
  return Promise.resolve(setLang(lang));
}
